export enum ExtraFeeMultiLengthConditionType {
  EndToEnd = 'end-to-end',
  SideToSide = 'side-to-side',
}
